module.exports = __webpack_public_path__ + "static/media/createPaymentLinkIcon.94658f72.svg";